import React from "react";
import { SideMenu, BackHeader } from "./../../components";
import { useNavigate } from "react-router-dom";
import "./transaction-history-view.css";
let TransactionHistoryView = (props) => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="page-container">
        <div className="transaction-history-view-header">
        <BackHeader backHanler={() => navigate(-1)} />
        <div className="transaction-history-view-status">Paid</div>
        </div>
        <div className="transaction-history-view-data-main">
          <p className="transaction-history-view-title">Student Name: </p>
          <p className="transaction-history-view-description">
            Willow Anderson
          </p>
        </div>
        <div className="transaction-history-view-data-main">
          <p className="transaction-history-view-title">Country: </p>
          <p className="transaction-history-view-description">burnside</p>
        </div>
        <div className="transaction-history-view-data-main">
          <p className="transaction-history-view-title">Bank name: </p>
          <p className="transaction-history-view-description">HDFC Bank</p>
        </div>
        <div className="transaction-history-view-data-main">
          <p className="transaction-history-view-title">Amount: </p>
          <p className="transaction-history-view-description">2000</p>
        </div>
        <div className="transaction-history-view-data-main">
          <p className="transaction-history-view-title">Date: </p>
          <p className="transaction-history-view-description">04-01-2022</p>
        </div>
        <div className="transaction-history-view-data-main">
          <p className="transaction-history-view-title"> Course name: </p>
          <p className="transaction-history-view-description">
            Nam ac velit eu magna placerat mattis sit amet et velit. Cras
            eleifend ante id aliquam sagittis.
          </p>
        </div>
        <div className="transaction-history-view-data-main">
          <p className="transaction-history-view-title">Description</p>
        </div>
        <p className="transaction-history-view-description">
          Nam ac velit eu magna placerat mattis sit amet et velit. Cras eleifend
          ante id aliquam sagittis. Curabitur vitae neque neque. Phasellus et
          feugiat ex. Aenean ultricies est ut dignissim varius. Ut quis lacus
          auctor, faucibus neque scelerisque, tempus nunc. Maecenas consectetur
          purus sit amet nisl pharetra varius. Ut malesuada scelerisque purus,
          quis luctus dolor consectetur vel. Mauris lacinia neque ac ullamcorper
          scelerisque. Vestibulum elementum iaculis ex id ultricies. Phasellus a
          justo dolor. Sed quis ex nec risus mattis volutpat.
        </p>
      </div>
    </SideMenu>
  );
};
export default TransactionHistoryView;
